import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, ButtonBase, Grid, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';
import MachineAvailabilityModal from './MachineAvailabilityModal';

const getStatusColor = (status) => {
  switch (status) {
    case "Available":
      return "#4caf50"; // green
    case "In Use":
      return "#ff9800"; // orange
    case "Breakdown":
      return "#f44336"; // red
    case "Under Calibration":
      return "#f44336"; // red
    case "Under Maintenance":
      return "#f44336"; // red
    case "On Hold":
      return "#9e9e9e"; // default grey
    default:
      return "#fefefe"; // default grey
  }
};

const MachineAccordion = ({ category, categorizedMachines, toggleStatus }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
  const isMd = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const [expanded, setExpanded] = useState(category);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [isStatusModalOpen, setStatusModalOpen] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleToggleStatus = (machineId, status, remarks) => {
    // Implement your logic to update the machine status
    // For example, you can update the status in your state
    // and then make API calls to update the status on the server

    // Close the status modal
    toggleStatus(category, selectedMachine.machine_id, status, remarks);
    // console.log({ selectedMachine });
    setStatusModalOpen(false);
  };

  return (
    <>
      <Accordion key={category} expanded={expanded === category} onChange={handleChange(category)}>
        <AccordionSummary expandIcon={<ExpandMore />} aria-controls={`${category}-content`} id={`${category}-header`}>
          <Typography>{category}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            {categorizedMachines[category].map(machine => (
              <Grid item xs={isXs ? 12 : isSm ? 6 : isMd ? 2 : 2} key={machine.machine_id}>
                <Paper
                  elevation={2}
                  style={{
                    backgroundColor: getStatusColor(machine.availability),
                    cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center'
                  }}
                >
                  <ButtonBase
                    // onClick={() => toggleStatus(category, machine.machine_id)}
                    onClick={() => {
                      setSelectedMachine(machine);
                      setStatusModalOpen(true);
                    }}
                    sx={{
                      width: "100%",
                      height: "100%",
                      padding: '10px',
                    }}
                  >
                    {machine.machine_id}
                  </ButtonBase>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
      {/* Render the MachineStatusModal */}
      <MachineAvailabilityModal
        open={isStatusModalOpen}
        onClose={() => setStatusModalOpen(false)}
        machine={selectedMachine}
        toggleStatus={handleToggleStatus}

      />
    </>
  );
};

export default MachineAccordion;